<template>
	<div class="display-flex flex-column on-boarding-step-wrapper">
		<div class="selected-apps-container display-flex flex-column flex-justify-space-between">
			<h5 class="header">Your apps</h5>
			<PreviouslySelectedFavoriteApps class="previously-selected-favorite" />
		</div>
		<SelectFavoriteAppsMenuSearch ref="search" class="mt-4 search-field" :searchString.sync="searchString" />
		<CurrentSelectedApps
			class="pr-7"
			@remove-app="removeApp"
			v-if="currentSelectedApps.length > 0"
			:currentSelectedApps="currentSelectedApps"
		/>
		<AllAppsMenu
			@select-app="selectApp"
			:searchString="searchString"
			:currentSelectedApps="currentSelectedApps"
			class="all-apps-list-container overflow-y-auto pt-5 px-2 mt-3 mb-5"
		/>
		<AnemicButton :disabled="isSaveButtonDisabled" :loading="isLoading" @click="addSelectedApps" class="add-button" tile>
			Continue
		</AnemicButton>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import AllAppsMenu from '@/components/SelectFavoriteApps/AllAppsMenu.vue';
import CurrentSelectedApps from '@/components/SelectFavoriteApps/CurrentSelectedApps.vue';
import PreviouslySelectedFavoriteApps from '@/components/SelectFavoriteApps/PreviouslySelectedFavoriteApps.vue';
import SelectFavoriteAppsMenuSearch from '@/components/SelectFavoriteApps/SelectFavoriteAppsMenuSearch.vue';
import { allCalculatedDirectoryApps } from '@/store/modules/auth/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'OnBoardingFavoriteApps',
	props: { stepDetails: { type: Object } },
	components: {
		AllAppsMenu,
		CurrentSelectedApps,
		SelectFavoriteAppsMenuSearch,
		PreviouslySelectedFavoriteApps,
	},
	computed: {
		...mapGettersShorthand({ allCalculatedDirectoryApps }),
		isSaveButtonDisabled() {
			return this.isLoading || this.totalFavoriteAppsIncludingCurrent.length < 1;
		},
		totalFavoriteAppsIncludingCurrent() {
			return [...this.currentSelectedApps, ...this.allCalculatedDirectoryApps];
		},
	},
	methods: {
		...mapActions(['saveFavoriteApps']),
		markStepAsDone() {
			this.$emit('mark-step-as-done', this.stepDetails);
		},
		selectApp(app) {
			this.currentSelectedApps = [...this.currentSelectedApps, app];
			this.searchString = '';
			this.$refs.search?.focus();
		},
		removeApp(app) {
			this.currentSelectedApps = this.currentSelectedApps.filter((selectedApp) => selectedApp.id !== app.id);
		},
		async addSelectedApps() {
			const idsToMarkAsFavorite = this.currentSelectedApps.map(({ id }) => id);
			this.isLoading = true;
			try {
				if (idsToMarkAsFavorite?.length > 0) {
					await this.saveFavoriteApps({ favoriteAppsIds: idsToMarkAsFavorite });
				}
				this.searchString = '';
				this.currentSelectedApps = [];
				await this.markStepAsDone();
			} catch {
				this.$toast.error('Failed saving favorite apps. please try again later');
			} finally {
				this.isLoading = false;
			}
		},
	},
	data() {
		return {
			searchString: '',
			isLoading: false,
			currentSelectedApps: [],
		};
	},
};
</script>

<style scoped lang="scss">
.selected-apps-container {
	height: 96px;
	padding: 14px 8px;
	border-radius: 14px;
	background: #f9fafc;
}
.header {
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-weight: 300;
}
.search-field {
	max-width: 428px;
}
.all-apps-list-container {
	height: 274px;
	border-radius: 10px;
	border: 1px solid #d6ddea;
}
.add-button {
	width: 96px !important;
	height: 30px !important;
	font-size: 14px !important;
	padding: 0px 14px !important;
	border-radius: 10px !important;
	font-weight: normal !important;
	color: var(--white) !important;
	background: #5858ec !important;
	letter-spacing: 0.21px !important;
}
.previously-selected-favorite {
	::v-deep {
		.card-container {
			width: 40px;
			height: 40px;
			padding: 10px;
		}
	}
}
</style>
